import React, { useState } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import Button  from "react-bootstrap/Button";
import Offcanvas from 'react-bootstrap/Offcanvas';
import { Link } from "react-router-dom";
import {
   AiOutlineHome,
  AiOutlineAudit,
  AiOutlineStar,
  AiOutlinePaperClip,
  AiOutlineMessage
} from "react-icons/ai";
import {GiHamburgerMenu} from "react-icons/gi";

function Header() {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

  return (
<>
{[false].map((expand) => (
    <Navbar key={expand} expand={expand} className="mb-3 menu-bar" sticky="top">
      <Container fluid>
        <Navbar.Brand href="#"></Navbar.Brand>
        <Button className="menu-button" onClick={handleShow}>
        <GiHamburgerMenu style={{ fontSize: "30px"}}/><br/>
            Menu
      </Button>
        <Offcanvas
          id={`offcanvasNavbar-expand-${expand}`}
          aria-labelledby={`offCanvasMenu-expand-${expand}`}
          placement="end"
          show={show} onHide={handleClose}
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title id={`offCanvasMenu-expand-${expand}`}>
              Menu
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Nav className="justify-content-end flex-grow-1 pe-3">
              <Nav.Link  as={Link} to="/"><AiOutlineHome style={{ marginBottom: "2px" }} /> Home</Nav.Link>
              <Nav.Link  as={Link} to="/rules"><AiOutlineAudit style={{ marginBottom: "2px" }} /> Rules</Nav.Link>
              <Nav.Link as={Link} to="/interests"><AiOutlineStar style={{ marginBottom: "2px" }} />  Interests</Nav.Link>
              <Nav.Link as={Link} to="/fanworks"><AiOutlinePaperClip style={{ marginBottom: "2px" }} />  Fanworks</Nav.Link>
              <Nav.Link as={Link} to="/contact"><AiOutlineMessage style={{ marginBottom: "2px" }} />  Contact</Nav.Link>
            </Nav>
          </Offcanvas.Body>
        </Offcanvas>
      </Container>
    </Navbar>
          ))}
  </>
  );
}

export default Header;
